import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { highcharts } from '@lib/highcharts';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-executive-chart-section',
  templateUrl: './executive-chart-section.component.html',
  styleUrls: ['./executive-chart-section.component.css']
})
export class ExecutiveChartSectionComponent {

  @Input() chartOptionsList: any[] = [];
  @Input() Highcharts: typeof highcharts = Highcharts;
  @Output() chartInstance = new EventEmitter<any>();

  onChartInstance(event: any, index: number) {
    this.chartInstance.emit({ event, index });
  }

}
